(ns basic-components.inputs.allocation-split
  (:require
   [basic-components.inputs.footprint :refer [editor viewer display-string]]
   [common.localization :as loc]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [common.util :as cu]
   [cljs.reader :as edn]
   [frontend.bootstrap.components :as rbs]
   [reagent.dom :as rd]
   [ui.components.button.view :as button]))

(def row-keys [:revenue :ebitda])

(defn default-row
  [years]
  (reduce (fn [acc year]
            (assoc acc year nil))
          {}
          years))

(defn default-value
  []
  [])

(defn default-edit-value
  []
  [["" 100.0]])

(defn render-edit-mode
  [dom-atom clear-state! args]
  (let [{:keys [:value :placeholder :class-name
                on-change! on-key-down! unique-id]}
        args
        edit-value (or (:temp-value @dom-atom)
                       (when (coll? value) value))
        render-value (vec (or edit-value
                              (when (coll? value) value)
                              (default-edit-value)))
        sum (->> render-value
                 (map (fn [row]
                        (when (and (coll? row)
                                   (= 2 (count row))
                                   (number? (second row)))
                          (second row))))
                 (remove nil?)
                 (apply +))]
    [:div.allocation-split.mt-4
     [:table.allocation-split__table
      [:thead
       [:tr.allocation-split__header-row.d-none
        [:th.allocation-split__cell.allocation-split__cell-header
         (loc/tr :allocation.split/target)]
        [:th.allocation-split__cell.allocation-split__cell-header
         (loc/tr :allocation.split/split)]]]
      [:tbody.allocation-split__body
       (->> render-value
            (map-indexed
             (fn [idx row]
               (let [label (first row)
                     percentage (second row)]
                 (when (and row
                            (coll? row)
                            (= (count row) 2))
                   ^{:key (str "allocation-split-" idx)}
                   [:tr.allocation-split__table-row
                    [:td.allocation-split__table-cell
                     [:input
                      {:placeholder (or placeholder "")
                       :type        "text"
                       :class-name  "allocation-split__input"
                       :value       (or label)
                       :on-change   (fn [e]
                                      (let [changed-text (-> e
                                                             .-target
                                                             .-value)]
                                        (swap! dom-atom assoc :temp-value (assoc render-value idx [changed-text percentage]))))
                       :on-blur     (fn [e]
                                      (let [new-value (if (= label "")
                                                        (assoc render-value idx ["" percentage])
                                                        render-value)]
                                        (swap! dom-atom assoc :temp-value new-value)))
                       :on-key-down on-key-down!}]]
                    [:td.allocation-split__table-cell
                     [:input
                      {:placeholder (or placeholder "")
                       :type        "text"
                       :class-name  "allocation-split__input"
                       :value       (let [draw-value percentage
                                          min-decimal-count (if (nil? draw-value)
                                                              -1
                                                              (or (get-in @dom-atom [:decimals idx :decimal-count])
                                                                  -1))
                                          edit-negative? (get-in @dom-atom [:decimals idx :negative?])]
                                      (or (when draw-value
                                            (if (= draw-value "")
                                              (when edit-negative? "-")
                                              (fu/format-with-separators draw-value min-decimal-count edit-negative?)))
                                          ""))
                       :on-change   (fn [e]
                                      (let [input (-> e
                                                      .-target
                                                      .-value)
                                            float-value (fu/parse-float-info input "")
                                            new-cell-value (:float-value float-value)
                                            new-value (assoc render-value idx [label new-cell-value])]
                                        (swap! dom-atom assoc :temp-value new-value)
                                        (swap! dom-atom assoc-in
                                               [:decimals idx]
                                               {:decimal-count (or (:decimal-count float-value) -1)
                                                :negative?     (or (:negative? float-value) false)})
                                        (when on-change!
                                          (on-change! e new-value))))
                       :on-blur     (fn [e]
                                      (let [new-value (if (= percentage "")
                                                        (assoc render-value idx [label 0])
                                                        render-value)]
                                        (swap! dom-atom assoc :temp-value new-value)))
                       :on-key-down on-key-down!}]]
                    [:td.allocation-split__table-cell
                     [:span.allocation-split__delete
                      [:i.fal.fa-trash
                       {:on-click (fn [e]
                                    (swap! dom-atom assoc
                                           :temp-value
                                           (cond
                                             (= idx 0)
                                             (drop 1 render-value)
                                             (= idx (count render-value))
                                             (subvec render-value
                                                     0
                                                     (-> render-value
                                                         (count)
                                                         (dec)))
                                             :else
                                             (concat (subvec render-value 0 idx)
                                                     (subvec render-value (inc idx))))))}]]]]))))
            (remove nil?)
            (doall))]
      [:tfoot
       [:tr
        [:td.allocation-split__cell.allocation-split__cell--footer]
        [:td.allocation-split__cell.allocation-split__cell--footer
         [:span.allocation-split__sum
          sum
          [:span
           (let [roundedpercent (int (* 100 (.toFixed sum 2)))
                 hundredpercent 10000]
             (when-not (= roundedpercent hundredpercent)
               [button/secondary-open
                {:tooltip (loc/tr :allocation-split-sum-should-be-100)}
                [:i.fas.fa-exclamation-triangle.salmon.ml-2]]))]]]
        [:td]]]]
     [:a
      {:href       "#"
       :class-name (fu/cs "allocation-split__add-btn")
       :on-click   (fn [e]
                     (swap! dom-atom assoc :temp-value (vec (concat render-value [["" 0.0]]))))}
      [:i.fal.fa-plus.mr-2]
      (loc/tr :add-new)]]))

(defn render-read-mode
  [dom-atom args]
  (let [{:keys [:value :placeholder :class-name
                has-focus? on-focus! on-blur!
                :on-change! :on-key-down! :disabled?]}
        args
        edit-value (or (:temp-value @dom-atom)
                       (when (coll? value) value))
        render-value (vec (or edit-value
                              (when (coll? value) value)
                              (default-value)))
        total (some->> edit-value
                       (map second)
                       (apply +))]
    [:div.allocation-split__table
     (when (and render-value
                (> (count render-value) 0))
       [:ul.allocation-split__read-mode
        (->> render-value
             (map-indexed
              (fn [idx row]
                (let [label (first row)
                      percentage (second row)]
                  (when (and row
                             (coll? row)
                             (= (count row) 2))
                    ^{:key (str "allocation-split-" idx)}
                    [:li..allocation-split__read-mode-row
                     [:label.allocation-split__read-value
                      label]
                     [:span.allocation-split__read-value
                      (str percentage "%")
                      (when (and (= idx
                                    (->> render-value
                                         (count)
                                         (dec)))
                                 (not= 10000 (int (* 100 total))))

                        [button/secondary-open
                         {:tooltip (loc/tr :allocation-split-sum-should-be-100)}
                         [:i.fas.fa-exclamation-triangle.salmon.ml-2]])]]))))
             (doall))])
     (when (or (not value)
               (not (coll? value))
               (empty? value))
       [:a.allocation-split__add-btn
        {:href     "#"
         :on-click (fn [e]
                     (on-focus!)
                     (let [new-value (:temp-value (swap! dom-atom assoc :temp-value (vec (concat render-value [["" 0.0]]))))]
                       (on-change! e new-value)))}
        [:i.fal.fa-plus.mr-2]
        (if (empty? render-value)
          (loc/tr :add)
          (loc/tr :add-new))])]))

(defmethod editor :editor.type/allocation-split
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        {:keys [set-focusable-element! set-cancel-edit! set-save! on-change!
                on-focus! on-blur!]}
        args
        initial-value (:value args)
        set-save! (:set-save! args)
        clear-state! (fn []
                       (swap! dom-atom dissoc
                              :temp-value
                              :decimals))]
    (r/create-class
     {:display-name           "Allocation split"
      :component-did-mount    (fn [args]
                                (let []
                                  (swap! dom-atom assoc :initial-value initial-value)
                                  (when set-focusable-element!
                                    (set-focusable-element! (fn [e]
                                                              (on-focus!)
                                                              (on-change! e (concat initial-value [["" 0]])))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [e]
                                                        (swap! dom-atom dissoc :temp-value :edit-mode?)
                                                        (on-change! e initial-value)
                                                        (on-blur! e initial-value clear-state!)))) ;; save complete -> reset temp state
                                  (when (fn? set-save!)
                                    (set-save! (fn [e]
                                                 (when (fn? on-blur!)
                                                   (on-blur! e (:temp-value @dom-atom) clear-state!)))))))
      :component-will-unmount (fn [])
      :reagent-render         (fn [args]
                                (if (:has-focus? args)
                                  (render-edit-mode dom-atom clear-state! args)
                                  (render-read-mode dom-atom args)))})))

(defmethod display-string :editor.type/allocation-split
  [args]
  (let [value (:value args)
        arr (cond (string? value) (edn/read-string value)
                  (coll? value) value
                  :else value)]
    (cu/tab-separated-string arr)))

(defmethod viewer :editor.type/allocation-split
  [args]
  (r/create-class
   {:display-name   "allocation-split/viewer"
    :reagent-render (fn [args]
                      (let [data (:value args)
                            header [(loc/tr :allocation.split/target) (loc/tr :allocation.split/split)]]
                        [:div.allocation-split__preview
                         [:table.allocation-split__table
                          [:thead
                           [:tr.allocation-split__header-row.d-none
                            (doall
                             (for [h header]
                               ^{:key (str "read-only-allocation-split-header" h)}
                               [:th.allocation-split__cell.allocation-split__cell--header
                                h]))]]
                          [:tbody
                           (->> data
                                (map-indexed (fn [idx [target split]]
                                               ^{:key (str "read-only-allocation-split-" idx)}
                                               [:tr.allocation-split__table-row
                                                [:td.allocation-split__table-cell
                                                 target]
                                                [:td.allocation-split__table-cell
                                                 split]]))
                                (doall))]]]))}))
